export default __webpack_public_path__ + "static/media/addressbook_wechat_icon.f716d2bb.svg";